import * as React from 'react';
import {FunctionComponent} from 'react';
import {WorkoutInterval} from '../../../Models/WorkoutInterval';
import {PlainGraph} from '../../../Graphs/PlainGraph';
import {workoutIntervalsToStrokes} from '../../../Strokes/downloadedIndoorWorkoutToStrokes';

interface OwnProps {
    workoutIntervals: WorkoutInterval[];
}

export const PowerGraph: FunctionComponent<OwnProps> = ({workoutIntervals}) => {
    const strokes = workoutIntervalsToStrokes(workoutIntervals);

    if (strokes.some((stroke) => stroke.power === null)) {
        return null;
    }

    const values = strokes.map((stroke) => {
        return {x: stroke.totalTime.milliseconds, y: stroke.power!.watts};
    });

    // Each axis has 8 points, evenly spaced between min and max values of the data
    const axis: {
        x: Array<{
            value: number;
            label: string;
        }>;
        y: Array<{
            value: number;
            label: string;
        }>;
    } = {x: [], y: []};

    const minX = Math.min(...values.map((value) => value.x));
    const maxX = Math.max(...values.map((value) => value.x));
    const minY = 0;
    const maxY = Math.max(...values.map((value) => value.y));

    const xStep = (maxX - minX) / 8;
    const yStep = (maxY - minY) / 8;

    for (let i = 0; i < 8; i++) {
        axis.x.push({
            value: minX + xStep * i,
            label: '',
        });
        axis.y.push({
            value: minY + yStep * i,
            label: '',
        });
    }

    return <PlainGraph height={130} padding={{top: 0, right: 0, bottom: 0, left: 0}} axis={axis} values={values} />;
};
